import { render, staticRenderFns } from "./msw-catalog-login-option.vue?vue&type=template&id=65a5ecac&scoped=true&"
import script from "./msw-catalog-login-option.vue?vue&type=script&lang=tsx&"
export * from "./msw-catalog-login-option.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-catalog-login-option.vue?vue&type=style&index=0&id=65a5ecac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a5ecac",
  null
  
)

export default component.exports